import axiosInstance from '../services/AxiosInstance';

export const getMerchantCollections = (getData) => {
  return axiosInstance.get("collect/list", {
    params: getData,
  });
};

export const getMerchantCollectionsList = (getData) => {
  return axiosInstance.get("collect/list", {
    params: getData,
  });
};

export const getMerchantCollectionsCount = (data) => {
  return axiosInstance.get("collect/overview", {
    params: data,
  });
};